// Example Usage:
// register('wines', {
//   label: 'Wine Products',
//   filters: ['lastest', 'featured'],
//   views: ['grid', 'carousel']
// })

const registry = {}

export default {
  register(key, settings) {
    if (!Object.prototype.hasOwnProperty.call(registry, key)) {
      registry[key] = settings
    }
  },
  get(key) {
    return registry[key] || null
  },
  getAll() {
    return registry
  }
}
